export function downloadFileUtil(blob: any, fileName: string, originalFileName: string = '') {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = originalFileName != '' ? originalFileName : fileName;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
}
